export enum ModuleName {
  JobSync = "job-sync",
  Organic = "organic",
  Reporting = "reporting",
  JobSource = "job-source",
  Applies = "applies",
  CandidateTracking = "candidate-tracking",
  Insights = "insights",
  DirectApply = "direct-apply",
  Campaigns = "campaigns",
  WebAnalytics = "web-analytics",
  Chat = "chat",
}
